/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconExpand/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconExpand({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconExpand",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 16,
  height = 16,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconExpand.Svg"
  data-view-path={viewPath}
 viewBox="0 0 16 16"
 style={{'--as-1-15iWvM': alignSelf,'--mt-2-15iWvM': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-15iWvM': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-15iWvM': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-15iWvM': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-15iWvM': opacity,'--w-10-15iWvM': typeof width === 'number' ? `${width}px` : width,'--h-11-15iWvM': typeof height === 'number' ? `${height}px` : height,'--f-12-15iWvM': fill,'--a-7-15iWvM': isAnimated ? animation : "none",'--sd-8-15iWvM': isAnimated ? strokeDashoffset : 0,'--sd-9-15iWvM': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconExpand.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M1.714 0h9v16h-9A1.714 1.714 0 010 14.286V1.714C0 .768.768 0 1.714 0zm12.572 16h-2.143V0h2.143C15.233 0 16 .768 16 1.714v12.572c0 .947-.768 1.714-1.714 1.714zM3.758 4.625a.571.571 0 01.608.079L7.794 7.56a.571.571 0 010 .878l-3.428 2.857a.571.571 0 01-.937-.439V5.143c0-.222.128-.424.329-.518z"
 style={{'--f-12-15iWvM': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}